import { render, staticRenderFns } from "./importOwnerRoom.vue?vue&type=template&id=35947f5f"
import script from "./importOwnerRoom.vue?vue&type=script&lang=js"
export * from "./importOwnerRoom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports